module.exports = __webpack_public_path__ + "static/media/award.98a05427.png";